import { useSuspenseQuery } from "@tanstack/react-query";

import { getPerformanceByQuestionCategory } from "~/data/dashboard/dashboard.service";

export function PerformanceSection() {
  const { data: data } = useSuspenseQuery({
    queryKey: ["dashboard", "performance"],
    queryFn: getPerformanceByQuestionCategory,
    staleTime: Infinity,
  });

  return (
    <section className="flex-1 rounded-[20px] bg-white shadow-card p-5">
      <div className="flex items-center gap-3 mb-[10px]">
        <h2 className="text-[#2D2D2D] font-alternative font-semibold text-2xl uppercase">
          Desempenho por Categoria
        </h2>
        <span className="text-sm font-alternative bg-[#D3D3D3] text-[#5B5B5B] px-2 rounded h-5 flex justify-center items-center">
          Todas
        </span>
      </div>

      <div className="grid gap-[10px] overflow-y-auto" style={{ height: 302 }}>
        {data.map((category, i) => {
          const percent = category.possible_max_score
            ? Math.floor(
                (100 * category.total_score) / category.possible_max_score
              )
            : 0;
          const position = i + 1;
          return (
            <div key={category.category_name} className="mr-3">
              <span className="text-xs leading-5 font-medium flex items-center justify-between">
                <span>{category.category_name}</span>
                <span>{percent}%</span>
              </span>
              <div className="w-full bg-surface h-5 rounded-[20px]">
                <div
                  data-even={position % 2 == 0}
                  data-three={position % 3 === 0}
                  className="bg-secondary-1 data-[even=true]:bg-alternative-1 data-[three=true]:bg-red-500 h-5 rounded-[20px]"
                  style={{ width: `${Math.min(percent, 100)}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
